import { MediaPickerModal, type PickedFile } from '@iws/media-library'
import { createMediaService } from '@/lib/media/mediaService'
import { resolveMediaUrl } from '@/lib/media/resolveUrl'

const service = createMediaService()

interface MediaGalleryModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelect?: (files: any[]) => void
  multiple?: boolean
}

export const MediaGalleryModal = ({
  open,
  onOpenChange,
  onSelect,
  multiple = false,
}: MediaGalleryModalProps) => {
  const handleSelect = (files: PickedFile[]) => {
    if (onSelect) {
      onSelect(
        files.map((f) => ({
          ...f,
          url: f.url,
          id: f._id,
          filename: f.name,
        }))
      )
    }
  }

  return (
    <MediaPickerModal
      open={open}
      onOpenChange={onOpenChange}
      service={service}
      resolveUrl={resolveMediaUrl}
      onSelect={handleSelect}
      multiple={multiple}
    />
  )
}
